import React from 'react';
import { APP_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import Panel from './Panel';
import StackTracePanel from './StackTracePanel';

const ExplorePanel = (props: any) => {
  if (props.dimension === APP_DIMENSIONS.STRACK_TRACE) {
    return <StackTracePanel {...props} />;
  }
  return <Panel {...props} />;
};

export default ExplorePanel;
